<template>
  <v-card>
    <v-form @submit.prevent="submitAddVehicleType()" ref="addVehicleTypeForm">
      <v-card-title>
        <span class="headline">Add VehicleType</span>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-text-field label="* Name" v-model="vehicleType.name" :rules="typeNameRules"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="* Maximum tonnage"
              v-model.number="vehicleType.tonnage"
              :rules="tonnageRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              :items="vehicleTypeClasses"
              color="indigo"
              v-model="vehicleType.class"
              label="Class"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn :color="primaryNeutral" flat type="submit" :loading="addingVehicleType">Add</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import VehicleTypeService from "@/services/requests/vehicleService";
import ContractorService from "@/services/requests/contractorService";
import VehicleValidation from "@/services/validation/vehicleValidation";
export default {
  mixins: [VehicleValidation],
  data() {
    return {
      vehicleType: {
        name: "",
        tonnage: 0,
        class: "TRUCK"
      },
      vehicleTypeClasses: [
        {
          text: "Truck",
          value: "TRUCK"
        },
        {
          text: "Plant",
          value: "PLANT"
        }
      ],
      addingVehicleType: false,
      loadingContractors: false
    };
  },
  methods: {
    submitAddVehicleType() {
      if (!this.$refs.addVehicleTypeForm.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      this.addVehicleType();
    },
    addVehicleType() {
      this.loading = true;

      VehicleTypeService.addVehicleType(this.vehicleType)
        .then(result => {
          this.loading = false;
          //console.log(result);
          this.$store.commit("vehicleTypes/addToArrayState", {
            prop: "vehicleTypes",
            value: result.data.result
          });
          this.resetForm();
          this.snack({ color: "green", text: "VehicleType was added" });
          this.close();
        })
        .catch(err => {
          this.snackError();
          this.addingVehicleType = false;
          console.log(err);
        });
    },
    resetForm() {
      this.vehicleType.name = "";
      this.vehicleType.tonnage = 0;
      this.$refs.addVehicleTypeForm.resetValidation();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style>
</style>
